import { render, staticRenderFns } from "./PortalLayout.vue?vue&type=template&id=08439758&scoped=true&"
import script from "./PortalLayout.vue?vue&type=script&lang=ts&"
export * from "./PortalLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08439758",
  null
  
)

export default component.exports